/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Edit2': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M.75 13.969v3.437h3.438L14.325 7.268 10.888 3.83.75 13.97zM17.626 3.968L14.188.53 11.87 2.86l3.438 3.437 2.319-2.328z" _fill="#00204D"/>'
  }
})
